import { logger, GENERIC_ERROR_MESSAGE, isBrowser } from 'common-ui';
import { useRecoilValue } from 'recoil';
import { getRecoil, setRecoil } from 'recoil-nexus';
import type { ErrorResponse } from 'tsconfig/types';
import { authAtom } from '../../atoms/authAtom';
import { cartAtom } from '../../atoms/cartAtom';
import { getCurrentCartIdFromCookie } from '../../helpers/utils';
import { handleExistingCartId, handleNewCartId } from '../../services/cart';

export function useInitCartStateWithWebApi() {
  const { cartItems } = useRecoilValue(cartAtom);

  return async (): Promise<void> => {
    if (!isBrowser()) {
      logger.log('useInitCartStateWithWebApi skipping fetch as not in browser');
      return;
    }

    if (cartItems) {
      logger.log('skipping init fetch of cart data as already defined');
      return;
    }

    try {
      const { cartId } = getCurrentCartIdFromCookie();
      const authAtomState = getRecoil(authAtom);
      const cartHandler = cartId ? handleExistingCartId : handleNewCartId;
      await cartHandler(authAtomState);
    } catch (error: unknown) {
      const apiError = error as ErrorResponse;
      setRecoil(cartAtom, prevState => ({
        ...prevState,
        cartIsLoaded: true,
        cartError: {
          hasCartError: true,
          cartErrorMessage: apiError?.message || GENERIC_ERROR_MESSAGE,
        },
      }));
      logger.error('Error during cart state initialization:', error);
    }
  };
}
